<template>
  <div>
    <Navbar />
    <SlideShow />
    <Section1 />
    <Section2 />
    <Section3 />
    <Section4 />
    <Section5 />
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/shared/Navbar.vue";
import SlideShow from "@/components/shared/SlideShow.vue";
import Section1 from "@/components/home/Section1.vue";
import Section2 from "@/components/home/Section2.vue";
import Section3 from "@/components/home/Section3.vue";
import Section4 from "@/components/home/Section4.vue";
import Section5 from "@/components/home/Section5.vue";
import Footer from "@/components/shared/Footer.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    SlideShow,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Footer
  }
};
</script>
